import { ref, computed } from 'vue';
import { MAX_URLS_PER_UPLOAD } from '@/shared/config';

interface UrlUploadInstance {
  id: number;
  isValid: boolean;
}

export function useUrlUploadInstances() {
  const urlUploadInstances = ref<UrlUploadInstance[]>([{ id: 0, isValid: false }]);
  const nextInstanceId = ref(1);

  const addUrlUploadInstance = () => {
    if (urlUploadInstances.value.length >= MAX_URLS_PER_UPLOAD) {
      return;
    }
    urlUploadInstances.value.push({ id: nextInstanceId.value, isValid: false });
    nextInstanceId.value++;
  };

  const removeUrlUploadInstance = (index: number) => {
    if (urlUploadInstances.value.length > 1) {
      urlUploadInstances.value.splice(index, 1);
    }
  };

  const handleUrlValidityChange = (index: number, isValid: boolean) => {
    if (urlUploadInstances.value[index]) {
      urlUploadInstances.value[index].isValid = isValid;
    }
  };

  const resetInstances = () => {
    urlUploadInstances.value = [{ id: 0, isValid: false }];
    nextInstanceId.value = 1;
  };

  const areAllUrlsValid = computed(() => {
    return urlUploadInstances.value.every((instance) => instance.isValid);
  });

  const hasValidUrls = computed(() => {
    return urlUploadInstances.value.some((instance) => instance.isValid);
  });

  return {
    urlUploadInstances,
    nextInstanceId,
    addUrlUploadInstance,
    removeUrlUploadInstance,
    handleUrlValidityChange,
    resetInstances,
    areAllUrlsValid,
    hasValidUrls,
  };
}